import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Chip,
  Button,
  Card,
  CardContent,
  Stack,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

const OwnerTable = ({ owners = [], onEdit }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const StatusChip = ({ status }) => (
    <Chip
      label={status}
      color={status === "Approved" ? "success" : "error"}
      size="small"
    />
  );

  /* ================= MOBILE VIEW ================= */
  if (isMobile) {
    return (
      <Stack spacing={2}>
        {owners.map((owner) => (
          <Card key={owner._id} elevation={3}>
            <CardContent>
              <Typography variant="h6" fontWeight={600}>
                {owner.name}
              </Typography>

              <Typography variant="body2" color="text.secondary">
                Type: {owner.type}
              </Typography>

              <Typography variant="body2">
                Contact: {owner.contact_person}
              </Typography>

              <Typography variant="body2">
                Phone: {owner.phone?.join(", ")}
              </Typography>

              <Typography variant="body2">
                Email: {owner.email}
              </Typography>

              <Typography variant="body2">
                City: {owner.city}
              </Typography>

              <Box mt={1}>
                <StatusChip status={owner.approval_status} />
              </Box>

              <Box mt={2} textAlign="right">
                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => onEdit(owner)}
                >
                  Edit
                </Button>
              </Box>
            </CardContent>
          </Card>
        ))}
      </Stack>
    );
  }

  /* ================= DESKTOP VIEW ================= */
  return (
    <TableContainer component={Paper} elevation={3}>
      <Table>
        <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
          <TableRow>
            <TableCell><b>Name</b></TableCell>
            <TableCell><b>Type</b></TableCell>
            <TableCell><b>Contact Person</b></TableCell>
            <TableCell><b>Phone</b></TableCell>
            <TableCell><b>Email</b></TableCell>
            <TableCell><b>City</b></TableCell>
            <TableCell><b>Status</b></TableCell>
            <TableCell align="right"><b>Action</b></TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {owners.map((owner) => (
            <TableRow key={owner._id} hover>
              <TableCell>{owner.name}</TableCell>
              <TableCell>{owner.type}</TableCell>
              <TableCell>{owner.contact_person}</TableCell>
              <TableCell>{owner.phone?.join(", ")}</TableCell>
              <TableCell>{owner.email}</TableCell>
              <TableCell>{owner.city}</TableCell>
              <TableCell>
                <StatusChip status={owner.approval_status} />
              </TableCell>
              <TableCell align="right">
                <Button
                  size="small"
                  onClick={() => onEdit(owner)}
                >
                  Edit
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default OwnerTable;
